import { simple, dark } from "@clerk/themes";

export const sharedStyles = {
  baseTheme:   (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) ? dark : simple,
    
  elements: {
    // avatarBox: "hidden",
    // avatarImageActions: "hidden",
    logoImage: "",
    headerSubtitle: "",
    // organizationSwitcherTrigger: "dark:bg-zinc-800 dark:text-gray-300",
    organizationSwitcherPopoverActionButton: "dark:text-gray-300 dark:hover:text-gray-200",
    organizationSwitcherPopoverMain: "dark:bg-zinc-800 dark:text-gray-300 ",
    organizationSwitcherTrigger: " dark:bg-zinc-950 dark:hover:bg-zinc-800 px-2 py-1.5",
    organizationPreviewMainIdentifier: "font-normal dark:text-gray-300  hover:text-primary",
    formFieldLabel: "",
    headerTitle:
      "text-3xl font-semibold leading-tight tracking-tight text-gray-900 dark:text-gray-100 ",
    formFieldInput:
      "block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6",
    formButtonPrimary:
      "w-full  capitalize inline-flex justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
    // userButton: "dark:bg-zinc-800 dark:text-gray-300",
    userButtonBox:  "flex-row-reverse text-gray-700 dark:text-gray-300 !gap-[0.2rem] hover:bg-gray-100  dark:hover:bg-zinc-900 rounded-md px-3 py-1.5 w-full",
    userButtonPopoverMain: "dark:bg-zinc-700 dark:text-gray-300",
    userButtonPopoverActionButton: "dark:text-gray-300 dark:hover:text-gray-200",
    userButtonOuterIdentifier: "font-normal",
    avatarBox: "w-6 h-6",
    // navbar: "dark:bg-zinc-700 dark:text-gray-300",
  },
  // variables: {
  //   colorPrimary: '#0d9488'
  // }
};
 